import { dataGridColorParams } from "@platform/design-system";
import { iconSetMaterial, themeQuartz, Theme } from "ag-grid-community";

/**
 * Create the AG Grid theme for the Plan Editor
 * @returns Theme configured for the Plan Editor grid
 */
export function getPlanEditorTheme(): Theme {
  return themeQuartz.withPart(iconSetMaterial).withParams({
    ...dataGridColorParams,
    browserColorScheme: "inherit",
    columnBorder: true,
    // headerRowBorder: { width: 3 },
    fontSize: 14,
    headerFontSize: 14,
    iconSize: 14,
    spacing: 4,
    borderRadius: 0, // Remove all border radius for seamless alignment with RatesGrid
  });
}
